export const getInflowCategory = (url: string): string => {
  if (!url) return "Other";

  if (url.includes("sendenkaigi.com/user/guest?survey_id=")) {
    return "Survey_Wpdl";
  }
  if (url.includes("sendenkaigi.com/survey/member/?web_link_id=")) {
    return "Survey_Kankyo";
  }

  // --- 1. KANKYO BUSINESS (Check specific sub-paths first) ---
  if (url.includes("sendenkaigi.com/kankyo/media/search")) return "Kankyo-business_Media";
  if (url.includes("sendenkaigi.com/kankyo/event")) return "Kankyo-business_Event";

  if (url.includes("kankyo-business.jp/news")) return "Kankyo-business_News";
  if (url.includes("kankyo-business.jp/column")) return "Kankyo-business_column";
  if (url.includes("kankyo-business.jp/courses")) return "Kankyo-business_Education";

  if (
    url.includes("kankyo-business.jp/dictionary") ||
    url.includes("kankyo-business.jp/magazine") ||
    url.includes("kankyo-business.jp/subsidy") ||
    url.includes("kankyo-business.jp/solution-database") ||
    url.includes("kankyo-business.jp/authors")
  ) {
    return "Kankyo-business_Other";
  }
  // Domain root & affinity slugs (e.g., www-stg.kankyo-business.jp/some-slug)
  if (url.includes("kankyo-business.jp")) return "Kankyo-business";


  // --- 2. MARKETING ---
  if (url.includes("/marketing/media")) return "Marketing_Media";
  if (
    url.includes("/marketing/courses") ||
    url.includes("/marketing/editor-writer") ||
    url.includes("/marketing/bestseller-library") ||
    url.includes("educ.sendenkaigi.com/biz")
  ) {
    return "Marketing_Education";
  }
  if (url.includes("/marketing/books")) return "Marketing_Books";
  if (url.includes("/marketing/event")) return "Marketing_Event";
  if (url.includes("senden.co")) {
    return "Marketing_Award";
  }
  if (url.includes("/marketing")) return "Marketing";


  // --- 3. CREATIVE ---
  if (url.includes("/creative/media")) return "Creative_Media";
  if (
    url.includes("/creative/courses") ||
    url.includes("/creative/brain-creative-library") ||
    url.includes("/creative/copywriting")
  ) {
    return "Creative_Education";
  }
  if (url.includes("/creative/books")) return "Creative_Books";
  if (url.includes("/creative/event")) return "Creative_Event";
  if (url.includes("maca.sendenkaigi.com")) {
    return "Creative_Award";
  }
  if (url.includes("/creative")) return "Creative";

  if (url.includes("sst.sendenkaigi.com")) return "Sst";
  if (url.includes("jpm.sendenkaigi.com")) return "Jpm";
  if (url.includes("/user/survey/answer")) return "Survey_Event";

  if (url.includes("advertimes.com")) return "Advertimes";
  if (url.includes("mypage.sendenkaigi.com")) return "Mypage";
  if (url.includes("awardg.sendenkaigi.com")) return "Awardg";
  if (url.includes("bova.co")) return "bova";

  return "Other";
};